import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Manifest';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $create = ActionCreator.Async(MODULE, 'Create', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/manifest`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $createTrucking = ActionCreator.Async(
  MODULE,
  'CreateTrucking',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/manifest/trucking`, payload)
        .then((response) => {
          dispatch($createTrucking.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest/${id}`, payload)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $getByOrder = ActionCreator.Async(
  MODULE,
  'Get.By.Order',
  (order_id, payload) => {
    return async (dispatch) => {
      dispatch($processing($getByOrder.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/byorder/${order_id}`,
        payload
      )
        .then((response) => {
          dispatch($getByOrder.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getByOrder.OPERATION)));
    };
  }
);

export const $getByDelivery = ActionCreator.Async(
  MODULE,
  'GetByDelivery',
  (shipmentid, payload) => {
    return async (dispatch) => {
      dispatch($processing($getByDelivery.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/bydelivery/${shipmentid}`,
        payload
      )
        .then((response) => {
          dispatch($getByDelivery.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getByDelivery.OPERATION)));
    };
  }
);

export const $getLegsByDelivery = ActionCreator.Async(
  MODULE,
  'GetLegsByDelivery',
  (shipmentid, payload) => {
    return async (dispatch) => {
      dispatch($processing($getLegsByDelivery.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/leg/bydelivery/${shipmentid}`,
        payload
      )
        .then((response) => {
          dispatch($getLegsByDelivery.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getLegsByDelivery.OPERATION)));
    };
  }
);

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $updatePartial = ActionCreator.Async(MODULE, 'UpdatePartial', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}/partial`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/manifest/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});

export const $publish = ActionCreator.Async(
  MODULE,
  'Publish',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/manifest/${id}/publish`, payload)
        .then((response) => {
          dispatch($publish.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $unpublish = ActionCreator.Async(
  MODULE,
  'Unpublish',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/manifest/${id}/unpublish`, payload)
        .then((response) => {
          dispatch($unpublish.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $start = ActionCreator.Async(MODULE, 'Start', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}/start`, payload)
      .then((response) => {
        dispatch($start.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

// change
export const $driver = ActionCreator.Async(
  MODULE,
  'Change.Driver',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${id}/change/driver`,
        payload
      )
        .then((response) => {
          dispatch($driver.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $moda = ActionCreator.Async(
  MODULE,
  'Change.Moda',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${id}/change/moda`,
        payload
      )
        .then((response) => {
          dispatch($moda.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
export const $vendor = ActionCreator.Async(
  MODULE,
  'Change.Vender',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${id}/change/vendor`,
        payload
      )
        .then((response) => {
          dispatch($vendor.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $additional = ActionCreator.Async(
  MODULE,
  'Add.Additional',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/manifest/additional/${id}`, payload)
        .then((response) => {
          dispatch($additional.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $getAdditional = ActionCreator.Async(
  MODULE,
  'Get.Additional',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($getAdditional.OPERATION));

      return await Rest.GET(`${API_URL}/tms/manifest/additional/${id}/manifest`)
        .then((response) => {
          dispatch($getAdditional.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getAdditional.OPERATION)));
    };
  }
);

export const $showAdditional = ActionCreator.Async(
  MODULE,
  'ShowAdditional',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($showAdditional.OPERATION));

      return await Rest.GET(`${API_URL}/tms/manifest/additional/${id}`)
        .then((response) => {
          dispatch($showAdditional.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($showAdditional.OPERATION)));
    };
  }
);

export const $updateAdditional = ActionCreator.Async(
  MODULE,
  'UpdateAdditional',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/manifest/additional/${id}`, payload)
        .then((response) => {
          dispatch($updateAdditional.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $deleteAdditional = ActionCreator.Async(
  MODULE,
  'DeleteAdditional',
  (id) => {
    return async (dispatch) => {
      dispatch($processing($deleteAdditional.OPERATION));

      return await Rest.DELETE(`${API_URL}/tms/manifest/additional/${id}`)
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($deleteAdditional.OPERATION)));
    };
  }
);

export const $addJob = ActionCreator.Default(MODULE, 'Add.Job', (item) => {
  return (dispatch) => {
    dispatch($addJob.action({ item }));
    return true;
  };
});

export const $deleteJob = ActionCreator.Default(
  MODULE,
  'Delete.Job',
  (index) => {
    return (dispatch) => {
      dispatch($deleteJob.action({ index }));
      return;
    };
  }
);

// legs

// get leg by manifest id
export const $getLegs = ActionCreator.Async(MODULE, 'GetLegs', (id) => {
  return async (dispatch) => {
    dispatch($processing($getLegs.OPERATION));

    return await Rest.GET(`${API_URL}/tms/manifest/${id}/leg`)
      .then((response) => {
        dispatch($getLegs.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getLegs.OPERATION)));
  };
});

// show leg
export const $showLeg = ActionCreator.Async(
  MODULE,
  'ShowLeg',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($processing($showLeg.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}`,
        payload
      )
        .then((response) => {
          dispatch($showLeg.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($showLeg.OPERATION)));
    };
  }
);

// add legs
export const $addLeg = ActionCreator.Async(MODULE, 'AddLeg', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/manifest/${id}/leg/add`, payload)
      .then((response) => {
        dispatch($addLeg.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

// reverse
export const $reverse = ActionCreator.Async(
  MODULE,
  'Leg.Reverse',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(
        `${API_URL}/tms/manifest/${id}/leg/reverse`,
        payload
      )
        .then((response) => {
          dispatch($reverse.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
// sort
export const $sort = ActionCreator.Async(MODULE, 'Leg.Sort', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/tms/manifest/${id}/legs`, payload)
      .then((response) => {
        dispatch($sort.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

// arrival
export const $arrive = ActionCreator.Async(
  MODULE,
  'Leg.Arrival',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/arrival`,
        payload
      )
        .then((response) => {
          dispatch($arrive.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// departure
export const $depart = ActionCreator.Async(
  MODULE,
  'Leg.Depature',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/depature`,
        payload
      )
        .then((response) => {
          dispatch($depart.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// delivered
export const $delivered = ActionCreator.Async(
  MODULE,
  'Leg.Delivered',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/delivered`,
        payload
      )
        .then((response) => {
          dispatch($delivered.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// dispute
export const $dispute = ActionCreator.Async(
  MODULE,
  'Leg.Dispute',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/dispute`,
        payload
      )
        .then((response) => {
          dispatch($dispute.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// receive
export const $receive = ActionCreator.Async(
  MODULE,
  'Receive',
  (manifest_id, leg_id, job_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/job/${job_id}/receive`,
        payload
      )
        .then((response) => {
          dispatch($receive.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// unreceive
export const $unreceive = ActionCreator.Async(
  MODULE,
  'Unreceive',
  (manifest_id, leg_id, job_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/job/${job_id}/unreceive`,
        payload
      )
        .then((response) => {
          dispatch($unreceive.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// image
export const $legImage = ActionCreator.Async(
  MODULE,
  'Leg.Image',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/image`,
        payload
      )
        .then((response) => {
          dispatch($legImage.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// image get by leg

export const $imageLeg = ActionCreator.Async(
  MODULE,
  'Get.Image.Leg',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($processing($imageLeg.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/delivery/shipment/image/${manifest_id}/manifest/${leg_id}/leg`,
        payload
      )
        .then((response) => {
          dispatch($imageLeg.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($imageLeg.OPERATION)));
    };
  }
);


// image get by manifest

export const $getByManifest = ActionCreator.Async(
  MODULE,
  'Get.Image.Manifest',
  (manifest_id, ) => {
    return async (dispatch) => {
      dispatch($processing($getByManifest.OPERATION));

      return await Rest.GET(
        `${API_URL}/tms/delivery/shipment/image/${manifest_id}/manifest`)
        .then((response) => {
          dispatch($getByManifest.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getByManifest.OPERATION)));
    };
  }
);


export const $uploadImageLeg = ActionCreator.Async(
  MODULE,
  'Leg.Image.Upload',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/image`, payload)
        .then((response) => {
          dispatch($uploadImageLeg.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

// deleteLeg
export const $deleteLeg = ActionCreator.Async(MODULE, 'DeleteLeg', (manifest_id, leg_id) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.DELETE(`${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}`,{})
      .then((response) => {
        dispatch($deleteLeg.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
    };
  }
);


// deleteManifestJob
export const $deleteManifestJob = ActionCreator.Async(MODULE, 'DeleteManifestJob', (mid, jobid) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.DELETE(`${API_URL}/tms/manifest/${mid}/job/${jobid}`,{})
      .then((response) => {
        dispatch($deleteManifestJob.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
    };
  }
);

// collected
export const $collected = ActionCreator.Async(
  MODULE,
  'Leg.Collected',
  (manifest_id, leg_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/manifest/${manifest_id}/leg/${leg_id}/collected`,
        payload
      )
        .then((response) => {
          dispatch($collected.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);